import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numbersFormat',
    standalone: false
})
export class NumbersFormatPipe implements PipeTransform {

  transform(value: number | undefined, args?: any): any {
    // Check if value is defined and is a number
    if (value !== undefined && typeof value === 'number') {
      return value.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
    // Return a default value or an empty string if value is not valid
    return '';
  }
}